interface IconProps {
  color?: string;
}

export const PlusIcon = ({ color }: IconProps) => (
  <svg viewBox="264.32 363 281.57 286">
    <g clipPath="url(#2e7333e6f4)">
      <path
        fill={color}
        d="M372.191 472.867V398.77q.001-15.547 8.504-25.262 8.502-9.96 24.293-9.961 15.792 0 24.293 9.96 8.747 9.717 8.746 25.263v74.097h73.125q16.038-.001 25.266 8.746 9.476 8.501 9.477 24.051 0 15.789-9.477 24.535-9.228 8.747-25.266 8.746h-73.125v73.852q.001 15.792-8.746 25.508t-24.293 9.718q-15.55-.002-24.293-9.718c-5.668-6.48-8.504-14.98-8.504-25.508v-73.852h-73.125q-15.55-.001-25.265-9.476-9.476-9.717-9.477-23.805 0-15.55 9.235-24.05 9.472-8.748 25.507-8.747Zm0 0"
      ></path>
    </g>
  </svg>
);
